var p="kpc";export{p as Kpc};
